import React from 'react'
import { Modal, Button } from 'antd'
import { connect } from 'react-redux'

const mapStateToProps = ({ settings: { visibleModalID }, apps }) => ({ visibleModalID, apps })

@connect(mapStateToProps)
class ModalSubscriptionOngoing extends React.Component {
  handleCancel = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  handleProceedToSubscribe = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'apps/SUBSCRIBE_MODAL_PROCEED',
      onComplete: this.takeUserToSubscriptionURL,
    })
  }

  takeUserToSubscriptionURL = ({ error, cancelled, data }) => {
    if (!error && !cancelled && data.data) {
      if (data.data.link !== undefined) window.open(data.data.link, '_blank')
    }
  }

  render() {
    const { visibleModalID, apps } = this.props
    const modalID = 'subscriptionOngoing'
    const visible = modalID === visibleModalID

    return (
      <Modal
        className="com__modal"
        title=" "
        open={visible}
        maskClosable={false}
        onCancel={this.handleCancel}
        closable={false}
        footer={null}
      >
        <div className="com__congrats">
          <p className="com__congrats__heading">
            <strong className="mr-4">Plan Subscription</strong>
          </p>
          <p className="font-size-21">
            Once you provide us with the payment details, come back and click proceed to update your
            current plan.
          </p>
          <br />
          <br />
          <Button type="primary" className="width-200 mr-3" onClick={this.handleCancel}>
            Close
          </Button>
          <Button
            type="primary"
            loading={apps.loading}
            className="width-200"
            onClick={this.handleProceedToSubscribe}
          >
            Proceed
          </Button>
        </div>
      </Modal>
    )
  }
}

export default ModalSubscriptionOngoing
